export default __webpack_public_path__ + "static/media/bookmark.eaeed589.svg";